import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export function formatPrice(price) {
  return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", minimumFractionDigits: 0 }).format(price);
}

export const STORAGE_PUBLIC_BASE_URL = (process.env.REACT_APP_STORAGE_PUBLIC_BASE_URL || process.env.REACT_APP_R2_PUBLIC_BASE_URL || "https://s3.growc.id/public/51bc8606-8a74-498f-992b-86e475bd5d94-e824298f").replace(/\/$/, "");
export const R2_PUBLIC_BASE_URL = STORAGE_PUBLIC_BASE_URL;

export function getImageUrl(path) {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("data:")) return path;
  
  let cleanPath = path;
  const servingPrefix = "/api/files/";
  if (cleanPath.includes(servingPrefix)) {
    cleanPath = cleanPath.substring(cleanPath.indexOf(servingPrefix) + servingPrefix.length);
  } else if (cleanPath.includes("api/files/")) {
    const p = "api/files/";
    cleanPath = cleanPath.substring(cleanPath.indexOf(p) + p.length);
  }
  if (cleanPath.startsWith("/")) cleanPath = cleanPath.substring(1);
  if (STORAGE_PUBLIC_BASE_URL.includes("s3.growc.id/public/") && cleanPath.startsWith("public/")) {
    cleanPath = cleanPath.substring("public/".length);
  }

  return `${STORAGE_PUBLIC_BASE_URL}/${cleanPath}`;
}

export default API;
